export default __webpack_public_path__ + "static/media/32.30a1f156.jpeg";